import React, { useState } from "react";
import { Modal, Form, Row, Col, Button, Table, message } from 'antd';
import { config } from "util/config";
import { httpClient } from 'util/Api';
import { useHistory } from "react-router-dom";
import * as globalFunction from 'util/GlobalFunction';
import AppNotificationContainer from 'components/AppNotificationContainer';
import PaymentHeader from '../Header';

const Invoice = () => {
  const history = useHistory();
  let pathname = window.location.pathname.split('/');

  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <InvoicePage invoiceId={pathname[pathname.length - 1]} history={history} />
  )
}
export default Invoice;

class InvoicePage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      invoice: null,
      submitting: false,
      getSessionSuccess: false
    }
  }

  componentDidMount() {
    this.addScript('https://anzworldline.gateway.mastercard.com/static/checkout/checkout.min.js');
    this.getInvoice();
  }

  getInvoice() {
    httpClient
      .get('/PublicPayment/MPGS/GetInvoice/' + this.props.invoiceId)
      .then(({ data }) => {
        if (data.result) {
          console.log(data.data);
          this.setState({ invoice: data.data });
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, this);
      });
  }

  getPaymentSession() {
    this.setState({ submitting: true });
    httpClient
      .get('/PublicPayment/MPGS/GetInvoiceOrderSession/' + this.props.invoiceId)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ submitting: false, getSessionSuccess: true });
          window.Checkout.configure({ session: { id: data.data } });
          window.Checkout.showEmbeddedPage('#embed-target');
          // window.Checkout.showPaymentPage();
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, this);
      });
  }

  addScript = (src) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.setAttribute('data-error', 'errorCallback');
    script.setAttribute('data-cancel', 'cancelCallback');

    document.body.appendChild(script);

    script.onload = () => {
      // Script loaded successfully
      console.log('Script loaded successfully.');
    };

    script.onerror = () => {
      // Handle script loading error
      console.log('Error loading script.');
    };
  }

  errorCallback = () => {
    // 错误回调函数
    console.log('Error callback function');
  }

  cancelCallback = () => {
    // 取消回调函数
    console.log('Cancel callback function');
  }

  showPayControl() {
    if (this.state.invoice.Status === 0 || this.state.invoice.InvoiceNumber.toLowerCase() === 'draft') {
      return <span style={{ fontWeight: 'bold' }}>This is a draft invoice. Online payment is not applicable.</span>
    }
    if (this.state.invoice.AccountingAppInvoiceId !== null && this.state.invoice.InvoiceStatus !== 'AUTHORISED' && this.state.invoice.DueAmount !== 0) {
      return <span style={{ fontWeight: 'bold' }}>Online payment is not applicable to this invoice.</span>
    }
    if (this.state.invoice.DueAmount === 0) {
      return <span style={{ fontWeight: 'bold' }}>This invoice has been paid.</span>
    }
    return <Button type="primary"
      style={{ width: '30%', minWidth: '200px' }}
      loading={this.state.submitting}
      disabled={this.state.submitting}
      hidden={this.state.getSessionSuccess}
      onClick={() => {
        this.getPaymentSession();
      }}>
      Pay Now
    </Button>
  }


  render() {
    return (
      <>
        {
          this.state.invoice !== null ?
            <div>
              <div className='public-payment-div' style={{ padding: '20px' }}>
                <Row gutter={config.component.gutter}>
                  {/* 与 NAB 付款页共用公司/模块对应的页头，避免两套付款入口显示不一致。 */}
                  <PaymentHeader job={this.state.invoice.Job} />
                  <Col span={24} style={{ marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Invoice {this.state.invoice.InvoiceNumber}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Date:</span> {globalFunction.truncateString(this.state.invoice.Date, 10)}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Due Date:</span> {globalFunction.truncateString(this.state.invoice.DueDate, 10)}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Invoice To:</span> {this.state.invoice.ContactName} {this.state.invoice.ContactCompany}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Job No.:</span> {this.state.invoice.Job.JobNum}</span>
                  </Col>
                  <Col span={24}>
                    <span><span style={{ fontWeight: 'bold' }}>Work Description:</span> {this.state.invoice.Job.WorkDescription}</span>
                  </Col>
                  <Col span={24} style={{ marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Invoice Details</span>
                  </Col>
                  <Col span={24}>
                    <Table
                      bordered
                      className='vertical-align-top-table'
                      pagination={false}
                      size="small"
                      dataSource={this.state.invoice.InvoiceLineItemList}
                      columns={[
                        {
                          title: 'Description',
                          dataIndex: 'Description',
                        },
                        {
                          title: 'Qty',
                          dataIndex: 'Quantity',
                        },
                        {
                          title: 'Unit Amount',
                          dataIndex: 'DiscountUnitAmount',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        },
                        {
                          title: 'GST',
                          dataIndex: 'TaxAmount',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        },
                        {
                          title: 'Amount',
                          dataIndex: 'Total',
                          align: 'right',
                          render: (data, record) => <>{globalFunction.formatMoney(data)}</>
                        }
                      ]}
                    />
                  </Col>
                  <Col span={24} style={{ textAlign: 'center', marginTop: '10px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Invoice Total: {globalFunction.formatMoney(this.state.invoice.Total)}</span>
                  </Col>
                  {
                    this.state.invoice.AccountingAppInvoiceId !== null ?
                      <Col span={24} style={{ textAlign: 'center', marginTop: '10px' }}>
                        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>Outstanding Balance: {globalFunction.formatMoney(this.state.invoice.DueAmount)}</span>
                      </Col> : <></>
                  }

                  <Col span={24} style={{ textAlign: 'center', marginTop: '10px' }}>
                    {
                      this.showPayControl()
                    }
                  </Col>
                </Row>
                <div id="embed-target" style={{ marginTop: '10px' }}></div>
              </div>
            </div> : <AppNotificationContainer loading={this.state.invoice == null} error={''} />
        }
      </>
    );
  }
};
